// extracted by mini-css-extract-plugin
module.exports = {"ActionButtons":"AdminPanel_ActionButtons__32nXk"};